import type { TertiaryButtonProps } from "@sb1/ffe-buttons-react";
import type { ElementType } from "react";
import { TertiaryButton as FellesTertiaryButton } from "@sb1f/buttons";
import { getCustomData } from "~/utils/tracking/utils";

type Props<As extends ElementType = "button"> = TertiaryButtonProps<As> & {
	track?: boolean;
	knappNavn?: string;
	trackingData?: object;
};

const TertiaryButton = <As extends ElementType = "button">({ track = true, trackingData, ...props }: Props<As>) => {
	const customData = trackingData ? { ...trackingData, ...getCustomData() } : getCustomData();
	return <FellesTertiaryButton customData={customData} {...props} />;
};

export default TertiaryButton;
